<div *ngIf="_messages?.length" [class]="type + '-message'" class="message" [ngClass]="{'cornered': isCornered}">
  <span class="alert-icon">
    <cx-icon class="cx-icon fas fa-exclamation-circle"></cx-icon>
  </span>
  <div class="message-list">
    <p *ngFor="let message of _messages;trackBy: trackById">{{message}}</p>
  </div>
  <button type="button" class="close" (click)="clearMessages()" *ngIf="!hideCloseButton">
    <cx-icon class="cx-icon fas fa-times">
    </cx-icon>
  </button>
</div>